import axios from "axios";
import { FEEDBACK_API_URL, GROUP_API_URL, GROUP_SCHEDULE_API_URL, LESSON_API_URL, PAYMENT_API_URL, RETREAT_API_URL, RETREAT_LESSON_API_URL, RETREAT_MONK_API_URL, RETREAT_REQ_API_URL, ROLE_API_URL, ROOMTYPE_API_URL, ROOM_API_URL, TOOLHISTORY_API_URL, TOOL_API_URL, USER_API_URL } from "./apisConfig";
//API ACCOUNT
const GetAllAccounts = (pageNumber, email = '', phoneNumber = '') => {
    const params = new URLSearchParams({ pageNumber });

    if (email) {
        params.append('email', email);
    }

    if (phoneNumber) {
        params.append('phoneNumber', phoneNumber);
    }

    return axios.get(USER_API_URL + `?${params.toString()}`, {
        withCredentials: true,
    });
}

const GetAccountsBySize = (pageSize) => {
    return axios.get(USER_API_URL + `?pageSize=${pageSize}`, {
        withCredentials: true,
        Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`

    });
}

const CreateAccount = (roleId, email, password, phoneNumber, firstName, lastName, dateOfBirth, gender) => {
    return axios.post(USER_API_URL, {
        roleId,
        email,
        password,
        phoneNumber,
        firstName,
        lastName,
        dateOfBirth,
        gender,
    });
}

const GetAccountByID = (id) => {
    return axios.get(USER_API_URL + `/${id}`, {
        id,
    });
}

const UpdateAccount = (id, oldPassword, newPassword, firstName, lastName, dateOfBirth, gender, status) => {
    return axios.put(USER_API_URL + `/${id}`, {
        oldPassword,
        newPassword,
        firstName,
        lastName,
        dateOfBirth,
        gender,
        status,
    });
}

//API ROLE
const GetAllRoles = () => {
    return axios.get(ROLE_API_URL, {
        withCredentials: true,
    });
}

//API ROOM

const GetAllRooms = (pageNumber, name = '') => {
    const params = new URLSearchParams({ pageNumber });

    if (name) {
        params.append('name', name);
    }
    return axios.get(ROOM_API_URL + `?${params.toString()}`, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateRoom = (roomTypeId, name, capacity, isActive) => {
    return axios.post(ROOM_API_URL, {
        roomTypeId,
        name,
        capacity,
        isActive,
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetRoomsBySize = (pageSize) => {
    return axios.get(ROOM_API_URL + `?pageSize=${pageSize}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetRoomByID = (id) => {
    return axios.get(ROOM_API_URL + `/${id}`, {
        id,
    });
}

const UpdateRoom = (id, name, capacity, status) => {
    return axios.put(ROOM_API_URL + `/${id}`, {
        name,
        capacity,
        status,
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}


//API ROOM TYPE
const GetAllRoomTypes = () => {
    return axios.get(ROOMTYPE_API_URL, {
        withCredentials: true,
    });
}

//API RETREAT
const GetAllRetreats = (pageNumber, name = '') => {
    const params = new URLSearchParams({ pageNumber });

    if (name) {
        params.append('name', name);
    }
    return axios.get(RETREAT_API_URL + `?${params.toString()}`, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetRetreatsBySize = (pageSize) => {
    return axios.get(RETREAT_API_URL + `?pageSize=${pageSize}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetCertification = (retreatId) => {
    return axios.post(USER_API_URL + `/dharma-name`, { retreatId }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetHistoryRetreats = (profileId) => {
    return axios.get(RETREAT_API_URL + `/${profileId}/retreats`, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetProgressRetreats = (retreatID) => {
    return axios.get(RETREAT_API_URL + `/${retreatID}/progress`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}



const CreateRetreat = (formData) => {
    return axios.post(RETREAT_API_URL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetretreatByID = (id) => {
    return axios.get(RETREAT_API_URL + `/${id}`, {
        id,
    });
}

const UpdateRetreat = (id, formData) => {
    return axios.put(RETREAT_API_URL + `/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
};

const GetRetreatLessons = (retreatId) => {
    return axios.get(RETREAT_LESSON_API_URL + `?retreatId=${retreatId}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateRetreatLesson = (retreatId, lessonId) => {
    return axios.post(RETREAT_LESSON_API_URL, {
        retreatId,
        lessonId,
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const DeleteRetreatLesson = (id) => {
    return axios.delete(RETREAT_LESSON_API_URL + `/${id}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetRetreatMonks = (id) => {
    return axios.get(RETREAT_MONK_API_URL + `?retreatId=${id}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateRetreatMonk = (retreatId, monkId) => {
    return axios.post(RETREAT_MONK_API_URL, {
        retreatId,
        monkId,
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const DeleteRetreatMonk = (id) => {
    return axios.delete(RETREAT_MONK_API_URL + `/${id}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetToolsBySize = (pageSize) => {
    return axios.get(TOOL_API_URL + `?pageSize=${pageSize}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}


//API TOOL

const GetAllTools = (pageNumber, name = '') => {
    const params = new URLSearchParams({ pageNumber });

    if (name) {
        params.append('name', name);
    }
    return axios.get(TOOL_API_URL + `?${params.toString()}`, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateTool = (name, totalTool, status, image) => {
    return axios.post(TOOL_API_URL, {
        name,
        totalTool,
        status,
        image,

    }, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetToolByID = (id) => {
    return axios.get(TOOL_API_URL + `/${id}`, {
        id,
    });
}

const UpdateTool = (id, name, totalTool, status, image) => {
    return axios.put(TOOL_API_URL + `/${id}`, {
        name,
        totalTool,
        status,
        image,
    }, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const DeleteTool = (id) => {
    return axios.delete(TOOL_API_URL + `/${id}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

//API LESSON

const GetAllLessons = (pageNumber, title = '') => {
    const params = new URLSearchParams({ pageNumber });

    if (title) {
        params.append('title', title);
    }
    return axios.get(LESSON_API_URL + `?${params.toString()}`, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetLessonsBySize = (pageSize) => {
    return axios.get(LESSON_API_URL + `?pageSize=${pageSize}`, {
        headers: {
            'accept': 'text/plain',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateLesson = (title, content) => {
    return axios.post(LESSON_API_URL, {
        title,
        content,
    },
        {
            headers: {
                Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
            }
        });
}

const GetLessonByID = (id) => {
    return axios.get(LESSON_API_URL + `/${id}`, {
        id,
    });
}

const UpdateLesson = (id, title, content) => {
    return axios.put(LESSON_API_URL + `/${id}`, {
        title,
        content,
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

//API TOOL HISTORY
const GetAllToolHistories = () => {
    return axios.get(TOOLHISTORY_API_URL, {
        withCredentials: true,
    });
}


const GetToolHistoryByID = (id) => {
    return axios.get(TOOLHISTORY_API_URL + `/${id}`, {
        id,
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateToolHistory = (retreatId, borrowerId, toolId, numOfTool) => {
    return axios.post(TOOLHISTORY_API_URL, {
        retreatId,
        borrowerId,
        // toolId,
        // numOfTool
    },
        {
            headers: {
                Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
            }
        });
}

const UpdateToolHistory = (id, numOfTool) => {
    return axios.put(TOOLHISTORY_API_URL + `/${id}`, {
        numOfTool,
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

//API FEEDBACK
const GetFeedbackbyRetreatID = (id) => {
    return axios.get(FEEDBACK_API_URL + `/${id}/feedbacks`, {
        id,
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

// API GROUP
const GetAllGroups = (pageNumber) => {
    const params = new URLSearchParams({ pageNumber });
    return axios.get(GROUP_API_URL + `?${params.toString()}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetGroupsBySize = (retreatId,pageSize) => {
    return axios.get(GROUP_API_URL + `?retreatId=${retreatId}&pageSize=${pageSize}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetGroupbyRetreatID = (id) => {
    return axios.get(GROUP_API_URL + `?groupId=${id}`, {
        id,
    }, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const UpdateMonkGroup = (formdata) => {
    return axios.post(GROUP_API_URL + `/assign-monk`,
        formdata
        , {
            headers: {

                'Content-Type': 'multipart/form-data',
                'accept': 'text/plain',
                Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
            }
        });
}
//Group schedule
const GetAllGroupSchedules = (pageSize,retreatScheduleId='') => {
    const params = new URLSearchParams({ pageSize });
    if (retreatScheduleId) {
        params.append('retreatScheduleId', retreatScheduleId);
    }
    return axios.get(GROUP_SCHEDULE_API_URL + `?${params.toString()}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateGroupSchedule = (formData) => {
    return axios.post(GROUP_SCHEDULE_API_URL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const UpdateGroupSchedule = (id, formdata) => {
    return axios.put(GROUP_SCHEDULE_API_URL + `/${id}`,
        formdata
        , {
            headers: {

                'Content-Type': 'multipart/form-data',
                'accept': 'text/plain',
                Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
            }
        });
}



const DeleteGroupSchedule = (id) => {
    return axios.delete(GROUP_SCHEDULE_API_URL + `/${id}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

export {
    GetAllAccounts, CreateAccount, GetAccountByID, GetAllRoles, UpdateAccount, GetCertification,
    GetAllRooms, GetAllRoomTypes, CreateRoom, GetRoomByID, UpdateRoom, GetRoomsBySize,
    GetAllRetreats, CreateRetreat, GetretreatByID, UpdateRetreat, GetHistoryRetreats, GetProgressRetreats, GetRetreatsBySize,
    GetAllTools, CreateTool, GetToolByID, UpdateTool, DeleteTool, GetToolsBySize,
    GetAllLessons, CreateLesson, GetLessonByID, UpdateLesson, GetLessonsBySize,
    GetAllToolHistories, GetToolHistoryByID, UpdateToolHistory, CreateToolHistory,
    UploadAvatar,
    GetRetreatLessons, CreateRetreatLesson, DeleteRetreatLesson,
    GetRetreatMonks, CreateRetreatMonk, DeleteRetreatMonk,
    GetAllPayments, GetAllPaymentByID, CreateRefundPayment,
    GetAccountsBySize,
    GetRetreatReqByUser,
    GetFeedbackbyRetreatID,
    GetAllGroups, GetGroupbyRetreatID, UpdateMonkGroup,GetGroupsBySize,
    GetAllGroupSchedules,CreateGroupSchedule,DeleteGroupSchedule,UpdateGroupSchedule,

}

//API UPLOAD AVATAR
const UploadAvatar = (formData) => {
    return axios.put(
        'https://plum-village.azurewebsites.net/api/accounts/avatar',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
                'accept': 'text/plain',
                Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
            },
        }
    );
};

//API PAYMENT

const GetAllPayments = (customerEmail = '') => {
    const params = new URLSearchParams();

    if (customerEmail) {
        params.append('customerEmail', customerEmail);
    }
    return axios.get(PAYMENT_API_URL + `?${params.toString()}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const GetAllPaymentByID = (id) => {
    return axios.get(PAYMENT_API_URL + `/${id}/payment`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}

const CreateRefundPayment = async (retreatRegId, emailPaypal, refundReason) => {
    try {
        const response = await axios.post(PAYMENT_API_URL + `/refund-money`, {
            retreatRegId,
            emailPaypal,
            refundReason
        }, {
            headers: {
                Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error creating refund payment:", error);
        throw error;
    }
}

const GetRetreatReqByUser = (UserID) => {
    return axios.get(RETREAT_REQ_API_URL + `?participantId=${UserID}`, {
        headers: {
            Authorization: `Bearer ${(localStorage.getItem("accessToken")).replace(/"/g, "")}`
        }
    });
}